import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import { useLocation } from "react-router-dom";
import { generarImagenReporte } from "../api/generarImagenReporte";
import { generarReportePsicometrico2B_Jumio } from "../api/generarReportePsicometrico2B_Jumio";
import Modal from 'react-bootstrap/Modal';
import parse from 'html-react-parser';
import "./print.css";
import "./style.css";
import { jsPDF } from "jspdf";

const PsicometricoReporteB_Jumio = () => {

  const componentRef = useRef(null);
  const isRunned = useRef(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [validateCurpCpv, setValidateCurpCpv] = useState(false);

  const [imagenFront, setImagenFront] = useState("");
  const [imagenBack, setImagenBack] = useState("");

  /*Varible de tarjeta de inicio*/
  const [usuarioTipo, setUsuarioTipo] = useState("")

  /*variables reporte*/
  const [usuarioAdecuacionPerfil, setUsuarioAdecuacionPerfil] = useState("");

  const [usuarioVigencia, setUsuarioVigencia] = useState("");
  const [usuarioCPV, setusuarioCPV] = useState("")
  const [usuarioDomicilioParticular, setusuarioDomicilioParticular] = useState("");
  const [usuarioDomicilioParticularEstatus, setusuarioDomicilioParticularEstatus] = useState("");
  const [usuarioDomiciliolaboral, setusuarioDomiciliolaboral] = useState("");
  const [usuarioDomiciliolaboralEstatus, setusuarioDomiciliolaboralEstatus] = useState("");
  const [usuarioIdentificacionContribuyente, setusuarioIdentificacionContribuyente] = useState("");
  const [usuarioIdentificacionContribuyenteEstatus, setusuarioIdentificacionContribuyenteEstatus] = useState("");
  const [usuarioNss, setusarioNss] = useState("");
  const [usuarioNssEstatus, setusuarioNssEstatus] = useState("");
  const [usuarioNumeroAlertas, setusuarioNumeroAlertas] = useState("");
  /*Variables Perfil de Aptitudes*/
  const [usuarioTendenciaDomicilios, setusuarioTendenciaDomicilios] = useState("Prueba button");

  const [usuarioObservacionReflexicaGrafica, setUsuarioObservacionReflexicaGrafica] = useState("");
  const [usuarioAbstractaGrafica, setUsuarioAbstractaGrafica] = useState("");
  const [usuarioExperienciaConcretaGrafica, setUsuarioExperienciaConcretaGrafica] = useState("");
  const [usuarioExperimentacionActivaGrafica, setUsuarioEsperimentacionActivaGrafica] = useState("");

  const [usuarioVerificacionIdentidad, setUsuarioVerificacionIdentidad] = useState("");
  const [usuarioCongruenciaRespuestaGrafica, setUsuarioCongruenciaRespuestaGrafica] = useState("");
  const [usuarioCongruenciaRespuesta, setUsuarioCongruenciaRespuesta] = useState("");
  const [usuarioRealizacionTiempoGrafica, setUsuarioRealizacionTiempoGrafica] = useState("");


  const [usuarioRealizacionTiempo, setUsuarioRealizacionTiempo] = useState("");
  const [usuarioTendencia, setUsuarioTendencia] = useState(false);

  /*Areas evaluadas*/
  const [usuarioResolucionProblemasGrafica, setUsuarioResolucionProblemasGrafica] = useState("");

  const [usuarioResolucionProblemas, setUsuarioResolucionProblemas] = useState("");

  const [usuarioautoGestionGrafica, setusuarioautoGestionGrafica] = useState("");

  const [usuarioautoGestion, setUsuarioautoGestion] = useState("");

  const [usuariocolaboracionGrafica, setusuariocolaboracionGrafica] = useState("");
  const [usuariocolaboracion, setUsuariocolaboracion] = useState("");

  const [usuariocomunicacionAcertivaGrafica, setUsuariocomunicacionAcertivaGrafica] = useState("");
  const [usuariocomunicacionAcertiva, setUsuariocomunicacionAcertiva] = useState("");

  const [usuariogestionEmocionalGrafica, setusuariogestionEmocionalGrafica] = useState("");
  const [usuariogestionEmocional, setUsuariogestionEmocional] = useState("");
  /*Datos de la persona Contribuyente*/
  const [usuarioTipoContribuyente, setusuarioTipoContribuyente] = useState("");
  const [usuarioNumeroContribuyente, setusuarioNumeroContribuyente] = useState("");
  const [usuarioNombreContribuyente, setusuarioNombreContribuyente] = useState("");
  const [usuarioEmisorContribuyente, setusuarioEmisorContribuyente] = useState("");
  const [usuarioPaisContribuyente, setusuarioPaisContribuyente] = useState("");
  const [usuarioFechaEmitidoContribuyente, setusuarioFechaEmitidoContribuyente] = useState("");
  const [usuarioEstatusContribuyente, setusuarioEstatusContribuyente] = useState("");
  const [tiempoRealizacion, settiempoRealizacion] = useState("");
  /*Perfil Predominante*/
  const [usuarioEstiloPredominante, setUsuarioEstiloPredominante] = useState("");
  /*Footer */
  const [usuarioFooterFecha, setUsuarioFooterFecha] = useState("");

  /*Estilo de Aprendizaje*/

  const [usuarioEstiloAprendizaje, setUsuarioEstiloAprendizaje] = useState("");
  const [usuarioObservaciones, setUsuarioObservaciones] = useState("");
  const [usuarioAdecuacionPerfilPorcentaje, setUsuarioAdecuacionPerfilPorcentaje] = useState("");
  const [usuarioVerificacionIdentidadGrafica, setUsuarioVerificacionIdentidadGrafica] = useState("");

  const [tiempoTest, setTiempoTest] = useState("");

  const [resolucionProblemasGraficaArr, setResolucionProblemasGraficaArr] = useState([]);
  const [autoGestionGraficaArr, setAutoGestionGraficaArr] = useState([]);
  const [coloboracionGraficaArr, setColoboracionGraficaArr] = useState([]);
  const [comunicacionAsertivaGraficaArr, setComunicacionAsertivaGraficaArr] = useState([]);
  const [gestionEmocionalGraficaArr, setGestionEmocionalGraficaArr] = useState([]);


  const [cardSvgP, setCardSvgP] = useState("");
  const [logoDPR, setLogoDPR] = useState("");
  const [check_deepBlue, setCheck_deepBlue] = useState("");
  const [cardSvgBlack, setCardSvgBlack] = useState("");
  const [qr, setQr] = useState("");

  /*---Nombre reporte---*/

  const date = new Date();
  const formattedDate = date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).split('/').reverse().join('-');
  const [cpv, setCpv] = useState(params.get("i"));

  /*-----------------------------------*/

  const [vigencia, setVigencia] = useState("");

  const [testImg, setTestImg] = useState("");

  const valorCicloAreas = 4;

  const handleClose = () => {
    setShow(false);
  }

  useEffect(() => {

    if (isRunned.current) return;
    isRunned.current = true;

    async function createSession() {

      localStorage.clear();

      if (params.get("i") == null) {

        setLoading(false);
        setModalShow(false);
        setShow(true);
        setShowStatus(500);
        setShowMessage("Error al obtener el cpv")

      } else {

        const objCpv = {
          curpValidate: params.get("i"),
        };

        const response = await generarReportePsicometrico2B_Jumio(objCpv);

        if (response.status === 200) {

          const cardSvgPStr =
            "data:image/png;base64," + response.cardSvgP + "";

          const logoDPRStr =
            "data:image/png;base64," + response.logoDPR + "";

          const check_deepBlueStr =
            "data:image/png;base64," + response.check_deepBlue + "";

          const cardSvgBlackStr =
            "data:image/png;base64," + response.cardSvgBlack + "";

          const qrStr =
            "data:image/png;base64," + response.qr + "";

          /** ---------------------------------------------------------------------------*/

          const adecuacionPerfilPorcentajeStr =
            "data:image/png;base64," + response.adecuacionPerfilPorcentaje + "";
          setUsuarioAdecuacionPerfilPorcentaje(adecuacionPerfilPorcentajeStr);

          const realizacionTiempoGraficaresponseStr =
            "data:image/png;base64," + response.realizacionTiempoGrafica + "";
          setUsuarioRealizacionTiempoGrafica(realizacionTiempoGraficaresponseStr);

          const congruenciaRespuestaGraficaStr =
            "data:image/png;base64," + response.congruenciaRespuestaGrafica + "";
          setUsuarioCongruenciaRespuestaGrafica(congruenciaRespuestaGraficaStr);

          const verificacionIdentidadGraficaStr =
            "data:image/png;base64," + response.verificacionIdentidadGrafica + "";
          setUsuarioVerificacionIdentidadGrafica(verificacionIdentidadGraficaStr);


          /** ---------------------------------------------------------------------------*/

          const observacionReflexicaGraficaStr =
            "data:image/png;base64," + response.observacionReflexicaGrafica + "";
          setUsuarioObservacionReflexicaGrafica(observacionReflexicaGraficaStr);

          const conceptualizacionAbstractaGraficaStr =
            "data:image/png;base64," + response.conceptualizacionAbstractaGrafica + "";
          setUsuarioAbstractaGrafica(conceptualizacionAbstractaGraficaStr);

          const experienciaConcretaGraficaStr =
            "data:image/png;base64," + response.experienciaConcretaGrafica + "";
          setUsuarioExperienciaConcretaGrafica(experienciaConcretaGraficaStr);

          const experimentacionActivaGraficaStr =
            "data:image/png;base64," + response.experimentacionActivaGrafica + "";
          setUsuarioEsperimentacionActivaGrafica(experimentacionActivaGraficaStr);

          const testImgStr =
            "data:image/png;base64," + response.testImg + "";
          setTestImg(testImgStr);


          /** ---------------------------------------------------------------------------*/

          setLogoDPR(logoDPRStr);
          setCardSvgP(cardSvgPStr);
          setCheck_deepBlue(check_deepBlueStr);
          setCardSvgBlack(cardSvgBlackStr);
          setQr(qrStr);
          setCpv(response.cpv);
          setUsuarioVigencia(response.fechaVencimiento);
          setUsuarioEstiloPredominante(response.estiloPredominante);
          setUsuarioTipo(response.tipo);
          setUsuarioAdecuacionPerfil(response.adecuacionPerfil);

          setUsuarioRealizacionTiempo(response.realizacionTiempo);
          setUsuarioVerificacionIdentidad(response.verificacionIdentidad);

          setTiempoTest(response.tiempoTest);
          setUsuarioCongruenciaRespuesta(response.congruenciaRespuesta);
          setUsuarioResolucionProblemasGrafica(response.resolucionProblemasGrafica);


          setUsuarioResolucionProblemas(response.resolucionProblemas);
          setUsuarioautoGestion(response.autoGestion);
          setUsuariocolaboracion(response.coloboracion);
          setUsuariocomunicacionAcertiva(response.comunicacionAsertiva);
          setUsuariogestionEmocional(response.gestionEmocional);
          setUsuarioFooterFecha(response.fecha);
          setUsuarioEstiloAprendizaje(response.estiloAprendizaje);
          setUsuarioObservaciones(response.observaciones);
          setUsuarioTendencia(response.tendencia);

          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.resolucionProblemasGrafica) {
              resolucionProblemasGraficaArr.push(<span className="mark"></span>)
            } else {
              resolucionProblemasGraficaArr.push(<span></span>)
            }
          }


          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.autoGestionGrafica) {
              autoGestionGraficaArr.push(<span className="mark"></span>)
            } else {
              autoGestionGraficaArr.push(<span></span>)
            }
          }


          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.coloboracionGrafica) {
              coloboracionGraficaArr.push(<span className="mark"></span>)
            } else {
              coloboracionGraficaArr.push(<span></span>)
            }
          }


          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.comunicacionAsertivaGrafica) {
              comunicacionAsertivaGraficaArr.push(<span className="mark"></span>)
            } else {
              comunicacionAsertivaGraficaArr.push(<span></span>)
            }
          }



          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.gestionEmocionalGrafica) {
              gestionEmocionalGraficaArr.push(<span className="mark"></span>)
            } else {
              gestionEmocionalGraficaArr.push(<span></span>)
            }
          }

          handlePrint();

        } else {

          setLoading(false);
          setShow(true);
          setShowStatus(response.status);
          setShowMessage(response.message);

        }

        /** ---------------------------------------------------------------------------*/

      }

    }

    createSession();

  }, []);


  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    print: async () => {
      const doc = new jsPDF();
      doc.html(componentRef.current, {
        html2canvas: {
          removeContainer: true,
          scale: 0.18,
        },
        margin: 5,
        x: 3,
        async callback(doc) {
          await doc.save('Examen Psicométrico_' + cpv + '_' + formattedDate);
        },
      });
    },

  });

  return (
    <>
      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className='backGroudModal'>
          <div className='msjTitleModalDiv'>Error {showStatus}</div>
          <div className='msjErrorModal'>{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='button_P2' onClick={handleClose}>
            <span className='txtButton_P2'>Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>

      <div className="w-100  justify-content-center" style={{ display: "flex", width: "965px", border: "none" }}>
        <div
          className=" animate__animated animate__fadeIn"
          ref={componentRef}
          style={{ display: "block", width: "1070px", border: "none" }}
        >
          <div className="relativeCSS">
            <style type="text/css" media="print">
              {
                "@page {  size: A4;  }"
              }
            </style>

            {/* hoja 1 */}


            {/* AQUI VA LA MAGIA DE LA FAX */}
            <br />
            <br />
            <div className="container-fluid">
              <section className="row">
                <div className="col-6">
                  <article className="identify-card ">
                    <aside className="account-detail gray w25">
                      <section className="detail-image">
                        <img src={logoDPR} alt="" />
                      </section>
                      <div className="detail-background">
                        <img src={cardSvgP} alt="" width={'75%'} height={'auto'} />
                      </div>
                    </aside>
                    <article className="middle-section">
                      <title className="title">
                        <div className="left">IDe</div>
                        <div className="right">
                          <strong>ERC PSICOMÉTRICO</strong>
                          <br />
                          <span>CREDENCIAL VERIFICABLE</span>
                        </div>
                      </title>
                      <section className="info-section gray">
                        <div className="subtitle">
                          <span>PROCESO DE CERTIFICACIÓN</span>
                          <h2>Aptitudes</h2>
                          <h4 >{usuarioTipo}</h4>
                        </div>
                        <hr className="division" />
                        <ul className="pNone">
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>AUTENTICACIÓN &nbsp; DE IDENTIDAD</span>
                          </li>
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>INFORMACIÓN REQUERIDA</span>
                          </li>
                        </ul>
                        <div className="expires">
                          <span className="text-lg">Vence:&nbsp;{usuarioVigencia}</span>
                        </div>
                      </section>
                    </article>
                    <article className="right-section">
                      <div className="detail-finance ">
                        <img src={cardSvgBlack} alt="" className="w50px" />
                      </div>
                      <section className="qr-code">
                        <img className="w50px" src={qr} alt="" />
                        <span className="cpv__text">CPV: {cpv}</span>
                      </section>
                      <section className="verify">
                        <img src={cardSvgP} alt="" />
                      </section>
                    </article>
                  </article>

                  <br />

                  <div className="titleCard">
                    VERIFICACIÓN DE AUTENTICIDAD
                  </div>
                  <div className="card verify-note">
                    <p className="f12"> El resultado obtenido  <strong> no es válido </strong> si la fecha en la parte superior izquierda de este
                      <strong> Reporte </strong> se encuentra <strong> vencida </strong> . Para comprobar su autenticidad escanee el código QR o ingrese directamente el código
                      <strong> CPV </strong> en <strong> www.midpr.net/verificar </strong> .
                    </p>
                  </div>
                  <small className="footer-note">
                    *Notifique si este Reporte es falso al +52 5571605526 y/o en www.midpr.net
                  </small>
                </div>
                <div className="col-6">
                  <h4 className="text-center">Examen &nbsp; Psicométrico</h4>
                  <p className="f12">
                    Este <strong>&nbsp; Reporte </strong>
                    da constancia de la calificación resultante de la aplicación de manera
                    <strong> completa y concluyente </strong>
                    de esta Evaluación Remota Confiable (ERC&nbsp;) realizada por el
                    <strong> Aplicante </strong>
                    , obteniendo los siguientes resultados:
                  </p>

                  <div className="titleCard">
                    RESULTADO &nbsp; OBTENIDO
                  </div>
                  <article className="card result">

                    <section className="graph-half-circle position-relative mb-4">
                      <img src={usuarioAdecuacionPerfilPorcentaje} alt="" />
                      <span className="percent-graph percentGraph__sizing">{usuarioAdecuacionPerfil}</span>
                    </section>
                    <div className="d-flex justify-content-center  align-items-center">
                      <button type="button" className="btn gray">ADECUACIÓN &nbsp; AL PERFIL</button>
                    </div>
                  </article>
                  <small className="footer-note ">
                    *La interpretación de este resultado obtenido es responsabilidad exclusiva de quien lo recibe.
                  </small>
                </div>
              </section>

            </div>

            <div className="container-fluid">
              <div className="row">
                <div className="col-6 ">
                  <br />
                  <div className="titleCard">
                    PERFIL &nbsp;DE APTITUDES
                  </div>
                  <section className="card  aptitudes ">
                    <div className="circle">

                      <img className="" src={usuarioAbstractaGrafica} alt="" />
                      <img className="" src={usuarioObservacionReflexicaGrafica} alt="" />
                      <img className="" src={usuarioExperienciaConcretaGrafica} alt="" />
                      <img className="" src={usuarioExperimentacionActivaGrafica} alt="" />

                    </div>
                    <table className="f12">
                      <tbody>
                        <tr>
                          <td className="py-1">
                            <strong>RO</strong>
                            <br />
                            <span>
                              Observación
                              <br />
                              reflexiva
                            </span>
                          </td>
                          <td className="py-1">
                            <strong>AC</strong>
                            <br />
                            <span>Conceptualización
                              <br />
                              abstracta
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td className="py-1">
                            <span>
                              Experiencia
                              <br />
                              concreta
                            </span>
                            <br />
                            <strong>CE</strong>
                          </td>
                          <td className="py-1">
                            <span>
                              Experimentación
                              <br />
                              activa
                            </span>
                            <br />
                            <strong>AE</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </section>
                  <br />
                  <br />
                  <table className="three-graphics f12">
                    <tbody>
                      <tr>
                        <td>
                          <div className="graph-half-circle position-relative">
                            <img src={usuarioVerificacionIdentidadGrafica} alt="" />
                            <span className="percent-graph percentGraph__sizing ">{usuarioVerificacionIdentidad}</span>
                          </div>
                          <span className="label-graph">
                            Verificación
                            <br />
                            de identidad
                          </span>
                        </td>
                        <td>
                          <div className="graph-half-circle position-relative">
                            <img src={usuarioCongruenciaRespuestaGrafica} alt="" />
                            <span className="percent-graph percentGraph__sizing">{usuarioCongruenciaRespuesta}</span>
                          </div>
                          <span className="label-graph">
                            Congruencia
                            <br />
                            de los modelos
                          </span>
                        </td>
                        <td>
                          <div className="graph-half-circle position-relative">
                            <img src={usuarioRealizacionTiempoGrafica} alt="" />
                            <span className="percent-graph percentGraph__sizing">{usuarioRealizacionTiempo}</span>
                          </div>
                          <span className="label-graph">
                            Realización
                            <br />
                            en tiempo
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>


                  {usuarioTendencia ? (
                    <>
                      <div>
                        <div className=" d-flex justify-content-center align-items-center">
                          <button type="button" className="btn green trend">TENDENCIA &nbsp; A CONSISTENTE</button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <div className=" d-flex justify-content-center align-items-center">
                          <button type="button" class="btn yellow trend">TENDENCIA &nbsp; A INCONSISTENTE</button>
                        </div>
                      </div>
                    </>
                  )}

                  <small className="footer-note">*Consulte definiciones de estas métricas en www.midpr.net/resultados</small>
                  <br />
                  <p className="f12">
                    Esta <strong>&nbsp;ERC&nbsp;</strong>  fue realizada de manera automatizada a través de un dispositivo digital propiedad del
                    <strong> Aplicante </strong> . Durante el proceso, se registraron una serie de datos de carácter personal que fueron analizados, validados y/o verificados que permitieron, posterior al análisis de la información, la obtención del dictamen presentado con respecto a la
                    <strong> congruencia o incongruencia </strong>  de estos de manera integral.
                  </p>
                </div>
                <div className="col-6 ">
                  <br />
                  <div className="titleCard">
                    ÁREAS &nbsp; EVALUADAS
                  </div>
                  <div className="card evaluated-areas tipo-d f12">
                    <ul >
                      <li>
                        <div className="single">
                          <div className="title">Resolución de problemas</div>
                          <section className="graph-line">
                            <article className="content-graph">
                              {resolucionProblemasGraficaArr}
                            </article>
                            <article className="text-graph">
                              {usuarioResolucionProblemas}
                            </article>
                          </section>
                        </div>
                      </li>
                      <li>
                        <div className="single">
                          <div className="title">Autogestión</div>
                          <section className="graph-line">
                            <article className="content-graph">
                              {autoGestionGraficaArr}
                            </article>
                            <article className="text-graph">
                              {usuarioautoGestion}
                            </article>
                          </section>
                        </div>
                      </li>
                      <li>
                        <div className="single">
                          <div className="title">Colaboración</div>
                          <section className="graph-line">
                            <article className="content-graph">
                              {coloboracionGraficaArr}
                            </article>
                            <article className="text-graph">
                              {usuariocolaboracion}
                            </article>
                          </section>
                        </div>
                      </li>
                      <li>
                        <div className="single">
                          <div className="title">Comunicación asertiva</div>
                          <section className="graph-line">
                            <article className="content-graph">
                              {comunicacionAsertivaGraficaArr}
                            </article>
                            <article className="text-graph">
                              {usuariocomunicacionAcertiva}
                            </article>
                          </section>
                        </div>
                      </li>
                      <li>
                        <div className="single">
                          <div className="title">Gestión Emocional</div>
                          <section className="graph-line">
                            <article className="content-graph">
                              {gestionEmocionalGraficaArr}
                            </article>
                            <article className="text-graph">
                              {usuariogestionEmocional}
                            </article>
                          </section>
                        </div>
                      </li>
                    </ul>

                  </div>
                  <small className="footer-note">*Consulte al reverso de este Reporte las imágenes recabadas.</small>
                  <br />

                  <div className="d-flex justify-content-center  align-items-center mt-2">
                    <button type="button" className="btn gray"><span className="label-msg">{`Tiempo de realización: ${tiempoTest}`}</span></button>
                  </div>
                  <br />

                  <div className="titleCard">
                    PERFIL &nbsp; PREDOMINANTE
                  </div>
                  <div className="card family-income">
                    <p className="">De acuerdo con los datos obtenidos, se establece que el perfil predominante es: </p>
                    <h6>{usuarioEstiloPredominante}</h6>
                  </div>
                </div>
              </div>
            </div>
            <br />

            <section className="note-gray note-emit">
              <p>
                Se emite el presente Reporte el &nbsp;
                {usuarioFooterFecha}&nbsp;
                en calidad de
                <strong> INFORMACIÓN CONFIDENCIAL </strong>
              </p>

            </section>
            <small className="footer-note">*Consulte al reverso de este Reporte DPR nuestra Política de Privacidad y/o en www.midpr.net/privacidad</small>


            <div className="titleCard">AVISO &nbsp; LEGAL</div>
            <div class="card ">
              <p className="f12--sizing">La <strong>Calificación</strong> realizada de manera remota por el <strong>Aplicante</strong>, a la que hace referencia este <strong>Reporte</strong>, fue realizada a solicitud directa del <strong>Destinatario</strong>. Antes y durante la <strong>Calificación</strong>, fue autenticada la identidad del <strong>Aplicante</strong> y se registraron una serie de datos e información de carácter personal con su autorización expresa, lo cual permitió emitir una Evaluación Remota Confiable (ERC&nbsp;). El <strong>Destinatario</strong> acepta que todos los datos contenidos en el presente <strong>Reporte</strong> son confidenciales y de interés exclusivo y privado, que es compartida únicamente con el propósito que ha sido previamente informado por el <strong>Destinatario</strong> y que ha autorizado por el <strong>Aplicante</strong> previo a la aplicación de la <strong>Calificación</strong>. El <strong>Aplicante</strong> y/o el <strong>Destinatario</strong> de este Reporte aceptan de conformidad la responsabilidad sobre cualquier uso indebido o ilegal de este documento y su contenido, así como todos los términos y condiciones descritos al reverso. <strong>Una vez entregado este Reporte al Destinatario, el Fabricante se deslinda de toda responsabilidad sobre su interpretación, divulgación y uso</strong>.</p>
            </div>

            <p class="txt-center f12 mt-2"><strong>Business &nbsp; Prey SA de CV</strong> hace referencia que con número de registro <strong>DGSP/369-19/3919</strong>, está autorizada por la <strong>SSPC&nbsp;/DGSP</strong> para la aplicación de Pruebas y Evaluación de Control de Confianza de conformidad con los <strong>Lineamientos y Criterios Técnicos</strong> publicados en el Diario Oficial de la Federación (DOF) el <strong>28 de abril de 2020</strong>.</p>


            {/* hoja 2 */}

            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <div className="titleCard">
              ESTILOS &nbsp; DE APRENDIZAJE
            </div>
            <div className="card observations ">
              <p><strong>{usuarioEstiloAprendizaje}</strong></p>
              <p>{usuarioObservaciones}</p>
            </div>


            <div className="div-vertical">
              <div className="div-horizontal" id="div1">


                <div className="cardLeft">
                  <div className="subTitleCardTwo">
                    <b>Business Prey SA de CV (BP)</b>, Fabricante exclusivo en la
                    República Mexicana para DPR, con número de registro
                    autorización DGSP/369-19/3919 expedido por la Dirección
                    General de Seguridad Privada (DGSP) de la Secretaría de
                    Seguridad y Protección Ciudadana (SSPC) &nbsp; para la aplicación
                    de pruebas de evaluación de control de confianza en
                    términos de los Lineamientos y Criterios Técnicos que
                    deberán cumplir las Empresas de Seguridad Privada bajo la
                    Modalidad VI, previsto en el artículo 15 de la Ley Federal
                    de Seguridad Privada (LFSP), publicados con fecha de 28 de
                    abril de 2020, en el Diario Oficial de la Federación (DOF)
                    y en cumplimiento con lo dispuesto por los artículos 1, 3,
                    6, 7, 8, 12 y 14 de la Ley Federal de Protección de Datos
                    Personales en Posesión de los Particulares emite el
                    resultado de la presente Evaluación Remota Confiable
                    (ERC).
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Aplicación de la Evaluación ERC</b> La presente ERC fue
                    acotada a una Área de Interés específica mediante un
                    proceso remoto que el Aplicante aceptó de manera expresa y
                    totalmente voluntaria someterse a la evaluación, con la
                    finalidad de ser calificado en diversas Temáticas con lo
                    que se estimó el Resultado Obtenido, conforme a la
                    metodología y marcos de referencia establecidos por DPR
                    para tal efecto. Para la realización de la ERC, el
                    Aplicante utiliza dispositivos electrónicos de su
                    propiedad, fuera del control del Fabricante, por lo que se
                    aplican avanzados métodos de validación y verificación de
                    datos para asegurar su veracidad y autenticidad.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Declaración de Veracidad</b> Esta evaluación ERC &nbsp; puede o no
                    formar parte de un proceso de certificación que incluye
                    una Prueba DPR. Al presentar esta ERC, el Aplicante acepta
                    y se somete a una declaración bajo protesta de decir
                    verdad de proporcionar información fidedigna. La veracidad
                    de la misma puede ser comprobada durante o posteriormente.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Proceso de Calificación</b> La ERC incluye un conjunto de
                    Áreas Evaluadas que incluyen Temas de Interés que son
                    requisitados para obtener un Resultado y un Dictamen. La
                    información que se recaba y se procesa durante la
                    evaluación se describen en este Reporte y corresponden a
                    una dimensión particular de datos adquiridos del
                    Aplicante.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Interpretación de los Resultados</b> Esta ERC incluye los
                    diversas Temas de Interés para obtener un Resultado
                    Obtenido y el Dictamen de veracidad o congruencia, que son
                    exclusivamente un parámetro medido en porcentaje y/o una
                    valoración cualitativa correspondientemente, por lo que no
                    existe un valor o magnitud específica que sea aprobatoria
                    o no aprobatoria. Es responsabilidad exclusiva del
                    Destinatario establecer el umbral mínimo o máximo
                    esperado, para la determinación de la aceptación del
                    Aplicante o para la permanencia de acuerdo a los
                    Resultados Obtenidos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Emisión del Certificado</b> Al culminar de manera concluyente
                    esta ERC, el resultado se procesa en un periodo máximo de
                    24 horas. El resultado, datos y dictamen descrito en este
                    Reporte, es sellado digitalmente mediante un Certificado
                    Personal Verificable (CPV) de forma numérica o en QR que
                    puede ser utilizado para confirmar la vigencia y
                    autenticidad del mismo en la página
                    www.midpr.net/verificar. Este Reporte deberá ser
                    considerado como falso, si la consulta no resulta en la
                    leyenda de “Verificado”.
                  </div>
                </div>
                <div>
                  <div className="subTitleCardTwo">
                    <b>Privacidad de Datos Personales &nbsp;</b> Para efectos del
                    cumplimiento del artículo 9 de la Ley Federal de
                    Protección de Datos Personales en Posesión de los
                    Particulares (LFPDPPP)&nbsp;, el Aplicante de la ERC manifiesta
                    expresamente que otorgó su consentimiento para el
                    tratamiento de sus datos personales sensibles, durante los
                    procedimientos de recopilación y procesamiento, aceptando
                    los términos y condiciones para tales efectos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Uso de las Marcas</b> DPR y las marcas asociadas son marcas
                    registradas, protegida por los artículos 88 y 142 de la
                    Ley de Propiedad Industrial (LPI), así como el convenio de
                    París para efectos internacionales. El consumo o
                    adquisición de cualquiera de los servicios vinculados a
                    DPR y/o proporcionados por el Fabricante, no confieren al
                    Aplicante y/o al Destinatario el derecho de uso de las
                    marcas de DPR en ningún contexto y/o formato, ya que al
                    hacerlo podría resultar en actividad fraudulenta y ser
                    clasificado como un delito. La marca, propiedad
                    intelectual o cualquier otro tipo de secreto industrial
                    contenido en este Reporte, no autoriza el uso, explotación
                    comercial, venta, reproducción o distribución de dicha
                    información.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Uso de Información por Terceros</b> Al realizar la ERC, el
                    Aplicante autoriza la entrega del resultado obtenido al
                    Destinatario para el uso particular que ambos hayan
                    acordado. Para el caso exclusivo de Elementos de Seguridad
                    Privada, la entrega de este Reporte a la DGSP, se hará
                    conforme a lo previsto en el artículo 9 de los citados
                    Lineamientos y Criterios Técnicos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>
                      En DPR estamos a favor de la confianza profesional, la
                      honestidad y transparencia, la privacidad de datos
                      personales, la equidad de género, la inclusión financiera
                      y digital, la igualdad de oportunidades y la no
                      discriminación.
                    </b>
                  </div>

                  <div className="card evaluated-areas tipo-d borderCard">
                    <div className="titleContainerSinBorder">
                      TEMAS DE INTERÉS
                    </div>
                    <div className="subTitleCardTwo">
                      <ul className="espacio-ul-left">
                        <li>
                          <strong>Estilo de aprendizaje:</strong> Experiencia
                          concreta, observación reflexiva, conceptualización
                          abstracta, experimentación activa.
                        </li>
                        <li>
                          <strong>Resolución de Problemas:</strong> Análisis
                          de problemas, emociones involucradas, negociación,
                          optimización de resultados.
                        </li>
                        <li>
                          <strong>Autogestión:</strong> Automotivación,
                          priorización de trabajo, administración del tiempo,
                          evaluación de resultados.
                        </li>
                        <li>
                          <strong>Colaboración:</strong> Conducta proactiva,
                          trabajo en equipo, conciencia de limitaciones,
                          objetivos grupales, enfoque multidisciplinario.
                        </li>
                        <li>
                          <strong>Comunicación Asertiva:</strong> Comunicación
                          efectiva, escucha activa, expresión oportuna,
                          empatía.
                        </li>
                        <li>
                          <strong>Gestión Emocional:</strong>{" "}
                          Autoconocimiento, control inhibitorio, canalización
                          emocional.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <br />
                  <br />
                  <div className="note-gray">
                    <p>
                      <strong>Business Prey SA de CV</strong> con domicilio en
                      Alfonso Reyes 216 Dep L003, Col. Hipódromo, C.P. 06100 Alcaldía Cuauhtémoc, CDMX, México, es Fabricante exclusivo de
                      DPR. Para mayor información llame al +52 5571605526 o
                      visite el sitio <strong>www.midpr.net</strong>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PsicometricoReporteB_Jumio